import React from "react";
import "./terms-conditions.css";

const TermsConditions = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Terms & Conditions</h1>
      </header>

      <section className="tc-content mb-3">
        <p>
        Loanontip (Owned and Managed by RRYO Private Limited, Partnered with ACG Leasing Limited – RBI Registered NBFC)

        </p>
        <p>
          The use of this WebApp (shall hereinafter mean to include the “Mobile Application”) and the Policy on WebApp Use shall be governed by the laws of India.
The Policy on WebApp Use and your activity under this Policy constitute an “electronic record” in accordance with the provisions of the Information Technology Act, 2000, and the applicable rules made thereunder.

        </p>

        <h2> GENERAL</h2>
        <p>
       All persons (the “Users” or individually a “User” or “You” or “Your”) visiting the Loanontip Platform (the “App” which shall hereinafter mean to include both the Web Application and the Mobile Application) are required to read and acquaint themselves with this document prior to using the App.
        </p>

        <p>Access to and use of the App by a User shall be deemed to represent the User’s consent to these Terms and Conditions of Use and any amendments thereto (hereinafter collectively referred to as the “Policy on App Use”).
In case a User does not agree with these Terms and Conditions (as may be amended from time to time), he/she shall discontinue use of the App and refrain from visiting it in the future.
</p>

<p>The App is owned and operated by RRYO Private Limited, a company incorporated under the provisions of the Companies Act, 2013, having its registered office at [A -17/D, 3rd floor, Naraina industrial area, Phase - 2, New Delhi -110028] (hereinafter referred to as the “Operator”, “We”, “Us”, or “Loanontip”).</p>

<p>The purpose of the App is to facilitate, process, and expedite loan applications for and on behalf of ACG Leasing Limited, an RBI-registered Non-Banking Financial Company (NBFC), in accordance with the terms and conditions of the agreement executed between RRYO Private Limited and ACG Leasing Limited.</p>

<p>This Policy on App Use regulates the rights and obligations of the Operator and the Users regarding the use of the App and its services.The User is requested to read these Terms carefully before registering, accessing, browsing, downloading, or using the App. This document represents a legally binding agreement between the User and the Operator establishing the terms and conditions under which this App may be used.</p>

<p>In the event of any conflict between the terms and conditions of specific loan products, services, or agreements and these general Terms, the terms and conditions specific to such loan products or services shall prevail.</p>

<p>Users are therefore advised to read these Terms thoroughly before proceeding to register or transact through the Loanontip App.</p>

        <h2>Services Overview</h2>
        <p>
 The Loanontip App is a digital lending platform that enables Users to apply for short-term personal loans offered by ACG Leasing Limited.
These loans are subject to the terms and conditions of the Loan Agreement executed between the applicant (User) and the Lender.</p>

        <p>The App aims to make the lending experience fast, simple, and transparent by offering a fully digital journey—from application to approval and disbursal.</p>

        <p>To avail of a loan, the User must submit the following documents and information:

          <li>Aadhaar Document</li>
          <li>PAN Card</li>
          <li>Credit Bureau Report (accessed by the Lender through authorized bureaus)</li>
          <li>Bank Statement Verification (through automated API or manual upload)</li>
          <li>Digital Mandate for repayment of the loan</li>
          <li>Aadhaar-based E-sign via OTP</li>
        </p>

        <p>Upon receipt of this data, the App uses secure third-party services to authenticate and verify the User’s identity, bank statements, and other relevant information.
The verified data is then shared with ACG Leasing Limited, which independently assesses the loan application in accordance with its credit policy.
</p>
<p>
If the User’s application satisfies the Lender’s lending criteria, the loan amount is disbursed directly to the User’s verified bank account via secure electronic transfer, generally within a few hours of approval.</p>

<p>By submitting personal and financial details, including PAN, Aadhaar, and other KYC information, the User expressly authorizes <b>RRYO Private Limited, ACG Leasing Limited,</b> and their authorized partners to access, verify, and use such data for:</p>

<p>
  <li>Credit bureau checks</li>
  <li>KYC validation</li>
  <li>Creditworthiness assessment</li>
  <li>Fraud prevention</li>
  <li>Compliance with applicable RBI regulations</li>
</p>

<p>The App may also, with the User’s consent, collect non-personal device information such as location, storage, device model, Wi-Fi, and mobile network details. This helps improve risk assessment and personalize loan offers, strictly in accordance with applicable laws and the <b>RBI’s Digital Lending Guidelines </b>.</p>

        <h2>Registration</h2>
        <p>
        To apply for a loan or access certain features, Users are required to create an account on the Loanontip App.
        </p>

        <p> <b>Eligibility conditions include:</b>
          <li>The User must be an Indian citizen aged 18 years or above.</li>
          <li>The User must hold a valid PAN, Aadhaar, and bank account.</li>
          <li>The User must provide accurate and truthful personal and financial details.</li>
        </p>

        <p>By registering, the User authorizes the Operator and its NBFC partner to verify details through credit bureaus, CKYC, and third-party verification agencies. Any false or misleading information may result in suspension or termination of access.</p>

        <p>By completing registration, the User also consents to receive communications (including marketing offers) from Loanontip and its partners. Promotional messages can be unsubscribed at any time by writing to info@loanontip.com</p>


        <h2>Security</h2>
        <p>
      The App uses industry-standard encryption and data protection technologies to safeguard User data.
While every reasonable precaution is taken, Users acknowledge that no digital platform is immune to risks.</p>

        <p>Loanontip shall not be liable for unauthorized access, system breaches, or losses arising from factors beyond its control.</p>

        <h2>License and Access</h2>
        <p>RRYO Private Limited grants Users a limited, revocable, and non-transferable license to use the App solely for personal, lawful purposes.
Users shall not copy, distribute, resell, or exploit any part of the App for commercial purposes.</p>

<p>Any form of misuse, tampering, reverse engineering, or breach of App security shall lead to immediate suspension and potential legal action.</p>

        <h2>Communications</h2>

        <p>By using the App, the User consents to receive communications from Loanontip, RRYO Private Limited, and ACG Leasing Limited via calls, SMS, email, WhatsApp, and push notifications for:</p>
        <ul>
          <li>Loan application updates</li>
          <li>Repayment reminders</li>
          <li>Product and service notifications</li>
          
        </ul>
          <p>Essential notifications related to ongoing loans cannot be unsubscribed from.</p>


         <h2>User Obligations</h2>
        <p>Users agree to:</p>
        <ul>
          <li>Provide accurate and updated personal and financial information.</li>
          <li>Use the App only for lawful purposes.</li>
          <li>Not engage in any activity that may harm the App’s security, functionality, or reputation.</li>
          <li>Comply with RBI and other regulatory requirements.</li>
        </ul>

         <p>Any unauthorized access, misuse, or attempt to defraud will result in suspension and may lead to legal action.</p>


        <h2>Annual Percentage Rate (APR)</h2>
        <p>Annual Percentage Rate (APR) for loans facilitated through Loanontip shall range from 300% to 465% per annum. </p>

         <p>APR represents the all-inclusive cost of the loan, including the cost of funds, credit cost, operational cost, processing fees, verification charges, maintenance charges, and any other administrative costs, excluding contingent charges such as penal interest, late payment fees, or other default-related charges that may be levied on the borrower. </p>

         <p>The applicable APR for each borrower shall be clearly displayed at the time of loan offer and shall also be specified in the Loan Agreement executed between the borrower and ACG Leasing Limited.</p>


         <h2>Tenure</h2>
        <p>The loan tenure shall refer to the time period for which the loan is sanctioned and shall be clearly specified in the Transaction Documents / Loan Agreement.</p>

          <p>The tenure for personal loans facilitated through Loanontip generally ranges between 30 to 90 days, depending on the product type, loan amount, and borrower’s eligibility.</p>

          <p>Borrowers are advised to review the loan repayment schedule and tenure carefully before accepting the loan offer. </p>

         <h2>Force Majeure</h2>
        <p>Neither RRYO Private Limited (Loanontip) nor ACG Leasing Limited shall be liable for any failure or delay in the performance of their obligations under these Terms or under the Loan Agreement if such failure or delay is caused by circumstances beyond their reasonable control.</p>

        <p>These may include, but are not limited to, acts of God, fire, flood, earthquake, war, civil unrest, riot, strike, government orders, pandemics, or power and communication failures.</p>

        <p>In such circumstances, affected parties shall be excused from performance for the duration of the event and shall resume obligations once normal conditions are restored.</p>

        <h2>Waiver</h2>
        <p>No waiver of any breach, right, or provision under these Terms shall be deemed a waiver of any prior, concurrent, or subsequent breach of the same or any other provision.
No waiver shall be valid or effective unless made in writing and duly signed by an authorized representative of the waiving party.
</p>
<p>Failure to exercise or enforce any right shall not constitute a waiver of that right.</p>

        <h2>Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, neither RRYO Private Limited nor its affiliates shall be responsible for:</p>
        <ul>
          <li>Any indirect, incidental, or consequential damages</li>
          <li>Data loss or system failure</li>
          <li>Unauthorized access or disclosure of User data</li>
          <li>Service interruption or operational errors beyond reasonable control</li>
        </ul>

        <p>The User’s sole remedy is to discontinue using the App.</p>

        <h2>Indemnification</h2>
        <p>Users agree to indemnify and hold harmless RRYO Private Limited, its directors, employees, affiliates, and service providers against any losses, liabilities, or claims arising from: </p>

        <ul>
          <li>Misuse of the App</li>
          <li>Violation of these Terms</li>
          <li>Breach of any applicable law</li>
          <li>Any dispute with the Lender or third parties resulting from the User’s conduct</li>
        </ul>
  
        <h2>Termination</h2>
        <p>The Operator may terminate or suspend a User’s access to the App without notice if the User: </p>

         <ul>
          <li>Provides false or misleading information</li>
          <li>Misuses the App or engages in prohibited activity</li>
          <li>Violates any term or law applicable to digital lending</li>
        </ul>

        <p>Termination shall not affect any loan obligations or repayment commitments under existing Loan Agreements with ACG Leasing Limited.</p>

        <h2>Governing Law and Jurisdiction</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of India.
Any disputes arising in connection with these Terms shall be subject to the exclusive jurisdiction of the courts at New Delhi, India.
 </p>

        <h2>Privacy</h2>
        <p>The collection, storage, and use of personal data are governed by the Loanontip Privacy Policy, which forms an integral part of these Terms.
By using the App, Users consent to the processing of their personal and financial information as described in the Privacy Policy.
</p>

        <h2>Severability</h2>
        <p>If any provision, term, or condition of these Terms or the Loan Agreement is found to be invalid, unlawful, or unenforceable by a competent court, such provision shall be severed to the extent necessary, without affecting the remaining terms and conditions.
The remaining provisions shall continue in full force and effect to the maximum extent permitted by law.
</p>

        <h2>Notices</h2>
        <p>All notices, communications, and correspondences made or required to be given under these Terms shall be in writing and shall be deemed duly served upon receipt when sent by:</p>

        <ol>
          <li>Email,</li>
          <li>Registered Post Acknowledgement Due (RPAD), or</li>
          <li>Personal Delivery</li>
        </ol>

        <p>to the following addresses:</p>
        <p><b>If to Loanontip:</b> RRYO Private Limited</p>
        <p> A -17/D, 3rd floor, Naraina industrial area, Phase - 2, New Delhi -110028</p>
        <p>info@loanontip.com</p>

        <p><b>If to You (the User):</b></p>
        <p>To the email ID and/or residential address provided at the time of registration and account setup on the Loanontip App.</p>
        <p>All such communications shall be considered delivered and effective upon receipt by the intended party.</p>

        <h2>Entire Agreement</h2>
        <p>These Terms and Conditions, together with any supplementary terms, product-specific addenda, or written modifications issued by Loanontip or ACG Leasing Limited, constitute the entire agreement between the parties concerning the subject matter herein.</p>

        <p>Any prior agreements, communications, representations, or understandings (whether oral or written) not expressly included herein shall have no legal effect unless acknowledged and accepted in writing by Loanontip or ACG Leasing Limited.</p>

        <p>The User acknowledges that they have read, understood, and agreed to the Terms before using the Loanontip platform or availing any loan facility through it.</p>

        <h2>Disclaimers</h2>
        <p>The App and its services are provided on an “as is” and “as available” basis. RRYO Private Limited does not guarantee uninterrupted operation, accuracy, or error-free performance. Loanontip does not provide financial advice, and the approval or rejection of any loan application remains solely at the discretion of ACG Leasing Limited.</p>

        <p>The Operator shall not be liable for any delay, technical error, or service unavailability caused by external factors or third parties.</p>
      </section>
    </div>
  );
};

export default TermsConditions;
